import React from 'react';
import { Link } from 'react-router-dom';
import getAppConfigParm from '../../config/AppConfig';
 
class RepairBoxes extends React.Component {

    render() {

        let siteUrl = getAppConfigParm("siteUrl");

        return (
            <section className="repair-boxes-area">
                <div className="container">
                    <div className="row m-0">
                        <div className="col-lg-4 col-md-6 p-0">
                            <div className="single-repair-box">
                            {/*
                            <i className="icofont-laptop-alt"></i>  */}
                                <i className="icofont-ui-calendar"></i>
                                <h3>Schedule Events</h3>
                                <p>Easily schedule and capture event details.</p>
                                <p> &nbsp; </p>
                                {/* <Link to="/faq">Read More</Link> */}
                                <a href={`${siteUrl}/resources/faq`}>Read more</a>
                                <div className="img-box">
                                    <img src={require('../../assets/img/shape1.png')} alt="box" />
                                    <img src={require('../../assets/img/shape2.png')} alt="box" />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 p-0">
                            {/* removed active from here <div className="single-repair-box active">  */}
                            <div className="single-repair-box">
                                <i className="icofont-people"></i>
                                <h3>Manage People</h3>
                                <p>Quickly add, edit, and delete people from list. &nbsp; </p>
                                <p> &nbsp; </p>
                                {/*<Link to="/faq">Read More</Link>*/}
                                <a href={`${siteUrl}/resources/faq`}>Read more</a>
                                <div className="img-box">
                                    <img src={require('../../assets/img/shape1.png')} alt="box" />
                                    <img src={require('../../assets/img/shape2.png')} alt="box" />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3 p-0">
                            <div className="single-repair-box">
                                <i className="icofont-bars"></i>
                                <h3>Track Status</h3>
                                <p>Monitor attendee status and who's pitching in</p>
                                <p> &nbsp; </p>
                               {/*<Link to="/faq">Read More</Link>*/}
                               <a href={`${siteUrl}/resources/faq`}>Read more</a>
                                <div className="img-box">
                                    <img src={require('../../assets/img/shape1.png')} alt="box" />
                                    <img src={require('../../assets/img/shape2.png')} alt="box" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default RepairBoxes;


// WEBPACK FOOTER //
// ./src/components/versionSeven/RepairBoxes.js